import PlayerControlsLogic from 'src/playerDomain/components/PlayerControlsLogic';
import store from 'src/store';
import * as EpgEventsUtils from 'src/components/PersistentMiniEpg/Helpers/EpgEventsUtil';
import {
    AAFPLAYER_PLAY,
    AAF_CONTENT_IS_STARTOVER,
    AAF_CONTENT_IS_NPVR,
    AAF_CONTENT_IS_VOD,
} from 'src/AAFPlayer/constants';
import AAFPlayer from 'src/AAFPlayer/AAFPlayer';
import Metadata from 'src/requests/apa/Metadata';
import { MODAL_CHANGING_EPISODE, showModal } from 'src/actions/modal';
import { playFullMedia } from 'src/actions/playmedia';
import Translator from 'src/requests/apa/Translator';

type typeRedirect = 'inactivity' | 'return';

interface INextEpisode {
  extendedcommon: {
    media: {
      episode: {
        season: string;
        number: string;
      }
    }

  };
  title: string;
  id: string;
}

interface ISerieData {
    episodeNumber: string;
}

interface IInfoSerieDataLive {
    ext_episode_id: string | null;
    ext_season_id: string | null;
    ext_series_id: string | null;
}

interface ICurrentContent {
    api_date_begin: string;
    api_date_end: string;
    ext_episode_id: string | null;
    ext_season_id: string | null;
    ext_series_id: string | null;
    group_id: string;
}

interface IHistory {
    push: (path: string) => {};
}

//UTILS

const updateValuesStorageUnMount = (interval: number) => {
    PlayerControlsLogic.resetDataModalSleep();
    clearInterval(interval);
};

const updateValuesStorageToContinue = () => {
    const { isSerie } = store.getState().modalInactivity;

    PlayerControlsLogic.setValueStatePlaying({
        controlTime: new Date().getTime(),
        episodesCount: isSerie ? 1 : 0,
    });
};

const currentChannels = async () => {
    const { source = {} } = store.getState().player;
    const { videoid = '' } = source;
    const events = await EpgEventsUtils.getEventsByTimeThreshold(videoid, 0, 24);
    return events;
};

const validateTimesCurrentContent = (start: string, end: string) => {
    const startContent = `${new Date(start).toLocaleDateString()} ${new Date(
        start
    ).toLocaleTimeString()}`;
    const endContent = `${new Date(end).toLocaleDateString()} ${new Date(
        end
    ).toLocaleTimeString()}`;
    const nowDate = `${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`;

    return startContent <= nowDate && nowDate < endContent ? true : false;
};

const getCurrentContent = async (): Promise<ICurrentContent | undefined> => {
    const currentInitChannels: ICurrentContent[] = await currentChannels();
    const target: ICurrentContent | undefined = currentInitChannels.find(
        ({ api_date_begin, api_date_end }) =>
            validateTimesCurrentContent(api_date_begin, api_date_end)
    );
    return target;
};

const updateValuesStorageMount = async (contentStreamType: string) => {
    let api_date_end = '';
    if (contentStreamType === AAF_CONTENT_IS_STARTOVER) {
        const content = await getCurrentContent();
        api_date_end = content ? content.api_date_end : '';
    }

    PlayerControlsLogic.setValueStatePlaying({
        contentStreamType,
        controlTime: new Date().getTime(),
        playing: true,
        timeEndStartOver: api_date_end,
    });
};

const handleOnKeyPressModalInactivity = () => {
    const { isSerie = false, contentStreamType } = store.getState().modalInactivity;
    const { playerstate = '' } = store.getState().player;

    playerstate === AAFPLAYER_PLAY &&
        PlayerControlsLogic.setValueStatePlaying({
            controlTime: new Date().getTime(),
            episodesCount: contentStreamType !== AAF_CONTENT_IS_VOD ? 1 : 0,
        });
};

const handleRedirectModalInactivity = (
    onExit: () => {},
    history: IHistory,
    typeOfRedirect: typeRedirect
) => {
    const {
        contentStreamType = '',
        returnPath = {},
        inactivityPath = {},
    } = store.getState().modalInactivity;
    const pathRedirect = typeOfRedirect === 'inactivity' ? inactivityPath : returnPath;
    let urlRedirect: string = '';

    if (contentStreamType === AAF_CONTENT_IS_NPVR) urlRedirect = Translator.get(pathRedirect.npvr, '/node/miscontenidos');
    else if (contentStreamType === AAF_CONTENT_IS_VOD) urlRedirect = Translator.get(pathRedirect.vod, '');
    else urlRedirect = Translator.get(pathRedirect.live, '/node/homeuser');

    const withOutRedirect = () => onExit && onExit();
    const withRedirect =async (urlRedirect: string) => {
        await withOutRedirect();
        history.push(urlRedirect);
    };

    urlRedirect.includes('vcard') || urlRedirect === '' || !urlRedirect
        ? withOutRedirect()
        : withRedirect(urlRedirect);
};

/////

//VOD

export const modalInactivityPlayVODSeries = (next: INextEpisode, title: string = "", payway_token: string = ''): void =>{
    AAFPlayer.play();
    const changingEpisodeData = {
        seasonNumber: next ? next.extendedcommon.media.episode.season : "",
        episodeNumber: next ? next.extendedcommon.media.episode.number : "",
        episodeTitle: next ? next.title : "",
        serieTitle: title,
    };
    store.dispatch(
        showModal({ modalType: MODAL_CHANGING_EPISODE, modalProps: changingEpisodeData })
    );
    setTimeout(() => {
        const nextGid = {
            payway_token: payway_token,
            ispip: false,
            islive: false,
            ispreview: false,
            resume: 0,
            source: {
                videoid: next.id,
            },
            playerstate: 'PLAYING',
            event: null,
        };
        store.dispatch(playFullMedia(nextGid));
    }, 1000);
};

const modalInactivityStartVODSeries = (episodeNumber: number | string): void => {
    PlayerControlsLogic.setValueStatePlaying({
        isSerie: true,
        episodesCount: episodeNumber,
    });
};

//LIVE
const modalInactivityPlayOnLIVE = () => {
    AAFPlayer.resume();
};

const modalInactivityPauseOnLIVE = () => {
    AAFPlayer.pause();
};

const modalInactivityStartLIVESeries = async (groupId: string | number) => {
    const currentInitChannel = await getCurrentContent();
    const validateCurrentChannel = currentInitChannel
        ? currentInitChannel
        : {
              ext_episode_id: null,
              ext_season_id: null,
              ext_series_id: null,
              group_id: '',
          };
    const { ext_episode_id, ext_season_id, ext_series_id, group_id } = validateCurrentChannel;

    const isSerie = ext_episode_id && ext_season_id && ext_series_id ? true : false;

    PlayerControlsLogic.setValueStatePlaying({
        controlTime: new Date().getTime(),
        episodeNumber: isSerie ? ext_episode_id : -1,
        episodesCount: isSerie ? 1 : 0,
        group_id,
        isSerie,
        playing: true,
        season_id: isSerie ? ext_season_id : null,
        series_id: isSerie ? ext_series_id : null,
    });
};

const modalInactivityCountLIVESeries = async (): Promise<void> => {
    const {
        episodesCount,
        episodeNumber,
        playing,
        season_id,
        series_id,
        group_id: group_idStore,
    } = store.getState().modalInactivity;
    const currentInitChannel = await getCurrentContent();

    const validateCurrentChannel = currentInitChannel
        ? currentInitChannel
        : {
              ext_episode_id: null,
              ext_season_id: null,
              ext_series_id: null,
              group_id: '',
          };
    const { ext_episode_id, ext_season_id, ext_series_id, group_id } = validateCurrentChannel;

    const isSerie = ext_episode_id && ext_season_id && ext_series_id ? true : false;

    const isDifferentContent =
        episodeNumber !== ext_episode_id ||
        season_id !== ext_season_id ||
        series_id !== ext_series_id
            ? true
            : false;

    const changeValuesInSerie =
        playing && isSerie && isDifferentContent && episodeNumber !== -1 ? true : false;
    const validateGroupId = group_idStore !== group_id ? true : false;

    changeValuesInSerie &&
        PlayerControlsLogic.setValueStatePlaying({
            controlTime: new Date().getTime(),
            episodeNumber: ext_episode_id,
            episodesCount: episodesCount + 1,
            isSerie,
            playing: true,
            season_id: ext_season_id,
            series_id: ext_series_id,
        });

    validateGroupId &&
        PlayerControlsLogic.setValueStatePlaying({
            group_id,
        });
};

export {
    validateTimesCurrentContent,
    getCurrentContent,
    updateValuesStorageMount,
    updateValuesStorageUnMount,
    updateValuesStorageToContinue,
    handleOnKeyPressModalInactivity,
    handleRedirectModalInactivity,
    modalInactivityStartVODSeries,
    modalInactivityPlayOnLIVE,
    modalInactivityPauseOnLIVE,
    modalInactivityStartLIVESeries,
    modalInactivityCountLIVESeries,
};



// WEBPACK FOOTER //
// ./src/components/Modal/functions/ModalInactivity/functions.ts